<template>
    <div>
      <v-card-title class="tva-copy mt-1 pa-2">
        <span>
          En cas de problème relatif à vos factures, vous pouvez nous contacter via l'adresse mail {{ settings.companyEmail }}<br>
          TVA non applicable en vertu de l'article 44 CTVA.<br>Association sans but lucratif, non assujettie à la taxe sur la valeur ajoutée<br>
          En cas de besoin, cette facture servira d'attestation pour le remboursement évenutel auprès de votre mutuelle</span><br>
      </v-card-title >
      <v-card-title class="tva-footer mt-3 pa-2"><span>Siège administratif - {{ settings.companyAddress }} {{ settings.companyZip }} {{ settings.companyCity }}</span><v-spacer></v-spacer> <span>N° BCE {{ settings.companyBCE }}</span></v-card-title >
    </div>
</template>
<script>
export default {
  props: ['settings'],
  methods: {
    splitAddress (adr) {
      const [street, city] = adr.split(',')
      return `${street}<br>${city}`
    }
  }
}
</script>
